export default function handlestartCity(info, setData, startCity, setIndex) {
    const selectedCity = info.target.value;
    const cityIndex = startCity.indexOf(selectedCity);
    if (cityIndex === -1) {
        setIndex(0);
        setData((prevState) => ({
            ...prevState,
            startCity: '',
            pickupLocation: ''
        }));
    } else {
        setIndex(cityIndex);
        setData((prevState) => ({
            ...prevState,
            [info.target.name]: selectedCity,
            pickupLocation: ''
        }));
    }
}
